import { PROFILE_ROUTE_NAMES } from '../../../../../constants/route'

export function getApplicantProfileTabUrl({ applicantId, tab }) {
  return PROFILE_ROUTE_NAMES.rentalPortalApplicantProfile({
    additionalParams: `/${tab}`,
    id: applicantId,
  })
}
